export default __webpack_public_path__ + "static/media/item_8_active.1c154afb.png";